import { render, staticRenderFns } from "./SelfDiagnosisPage.vue?vue&type=template&id=5294bda0&scoped=true"
import script from "./SelfDiagnosisPage.vue?vue&type=script&lang=js"
export * from "./SelfDiagnosisPage.vue?vue&type=script&lang=js"
import style0 from "./SelfDiagnosisPage.vue?vue&type=style&index=0&id=5294bda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5294bda0",
  null
  
)

export default component.exports